import { Component, Inject, OnInit } from '@angular/core';
import { Sort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Issue } from 'src/app/lib/issue/classes';
import { IIssuesProvider, ISSUES_PROVIDER_SERVICE } from '../../../interfaces';

@Component({
  selector: 'app-issue-table',
  templateUrl: './issue-table.component.html',
  styleUrls: ['./issue-table.component.css']
})
export class IssueTableComponent implements OnInit {

  columns = [ 'issuenumber', 'issuetype', 'issuetitle', 'issuestate', 'controls' ];
  footerColumns = [ 'issuenumber' ];

  active: string = 'issuenumber';
  direction: SortDirection = 'asc';

  constructor(
    @Inject(ISSUES_PROVIDER_SERVICE) public providerService: IIssuesProvider,
    private _router: Router
  ) { }

  ngOnInit(): void { }

  showIssue = (issue: Issue) => this._router.navigate(['/issue-details', issue.issueid]);

  sortData(sort: Sort){
    this.active = sort.active;
    this.direction = sort.direction;
  }

}
